// http://kazupon.github.io/vue-i18n/en/messages.html

// import.meta.glob replaces webpack's require.context; relative pattern keeps
// the './path/file.json' key shape identical.
const requireLang = import.meta.glob('./**/*.json', { eager: true });

const messages = {};
interface Dict { [key: string]: string; }

for (const file of Object.keys(requireLang)) {
  const path = file.replace(/(\.\/|\.json$)/g, '').split('/');

  path.reduce((o: Dict = {}, s, i) => {
    if (o[s]) { return o[s]; }

    o[s] = i + 1 === path.length
      ? (requireLang[file] as any).default
      : {};

    return o[s];
  }, messages);
}

export default messages;
